import Contact from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Footer/Contact"
import Overview from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Footer/Overview"
import SocialLinks from "@/components/pages/MicroSite/Templates/FramebaseTemplate/Footer/SocialLinks";
import type { MicroSite } from "@/lib/api";

const Footer = ({data}:{data: MicroSite}) => {
    
  return (
    <div className="flex flex-col gap-4 p-4 lg:p-8 xl:p-16" style={{backgroundColor: data?.branding?.websiteColorCode}}>
      <div className="flex justify-between gap-4 flex-wrap">
        <img src={data?.branding?.websiteLogoUrl} alt="logo" className="h-12 min-w-fit w-fit object-contain" />
        <Overview data={data} />
      </div>

      <hr className="border-t border-gray-300 my-4 " />

<div className="grid lg:grid-cols-2 justify-between gap-8">
      <Contact data={data} />
    <SocialLinks data={data} />
</div>
    </div>
  )
}

export default Footer